import { connect } from 'react-redux'
import FormDialog from '../components/FormDialog'
import * as formDialogActions from '../actions/formDialogActions'
import * as login from '../actions/login'

const mapStateToProps = (state, ownProps) => {  
	return {
		...state.formDialog,
		roles: state.login.roles,
		username: state.login.username,
		environment: state.login.environment,
		countryTypeOptions: state.homePage.countryTypeOptions,
		accountTypeOptions: state.homePage.accountTypeOptions,
		nafaId: state.homePage.nafaId,
		lbbId: state.homePage.lbbId,
		nafaData: state.homePage.nafaData || state.formDialog.nafaData,
		moreResults: state.homePage.moreResults,
		subNafaOpen: state.homePage.subNafaOpen,
		subOpen: state.homePage.subOpen,
		goBack: state.homePage.goBack, 
		lbbFlag: state.homePage.lbbFlag
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({
	search: (searchObject, lbbId, nafaId, isLbb) => dispatch(formDialogActions.search(searchObject, lbbId, nafaId, isLbb)),
	closeNestedDialog: () => dispatch(formDialogActions.closeNestedDialog()),
	handleChangeValue: (event) => dispatch(formDialogActions.handleFormChangeValue(event)),
	handleChangeValueSelect: (event) => dispatch(formDialogActions.handleFormChangeValueSelect(event)),
	loadPref: (id,isLbb) => dispatch(formDialogActions.loadPref(id,isLbb)),
	cancel: () => dispatch(formDialogActions.cancel()),
	logout: () => dispatch(login.logout()),
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FormDialog)



// WEBPACK FOOTER //
// ./src/containers/FormDialogContainer.js